import * as React from "react";

import {Checkbox} from "../../common/design2/checkbox/checkbox";

import {mlContentDataColumns} from "./ml-content-data-columns";

export const MailingListRow = ({ml, mailingListIds, callingGetCass, showSource, onEdit, onRemove}) => [
    {
        render: () => {
            if (callingGetCass.isActive(ml.id)) {
                return (
                    <i className="fa fa-spinner fa-pulse"/>
                );
            }

            const checked = mailingListIds.value?.find((id) => id == ml.id) != null;

            return Checkbox({
                checked,
                onClick: async () => {
                    if (checked) {
                        mailingListIds.change((ids) => ids.filter((id) => id != ml.id));
                    } else {
                        await callingGetCass.invoke(ml.id);

                        mailingListIds.change((ids) => [
                            ...ids ?? [],
                            ml.id,
                        ]);
                    }
                },
                xdQaName: ml.mailingListName,
            });
        },
    },

    ...mlContentDataColumns({showSource, ml, onEdit, onRemove}),
];

